import { render, staticRenderFns } from "./PostJobForm.vue?vue&type=template&id=aaf24878"
import script from "./PostJobForm.vue?vue&type=script&lang=js"
export * from "./PostJobForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports